import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
	selector: "app-lang-select",
	templateUrl: "./lang-select.component.html",
	styleUrls: ["./lang-select.component.scss"],
})
export class LangSelectComponent implements OnInit {
	isActive = false;

	currentLang!: string;

	constructor(private translateService: TranslateService) {}

	ngOnInit() {
		this.initLang();
	}

	initLang() {
		if (localStorage.getItem("locale") === "ru") {
			this.currentLang = "LANG.RU";
		}
		if (localStorage.getItem("locale") === "kk") {
			this.currentLang = "LANG.KK";
		}
	}

	changeLang(lang: string) {
		this.translateService.use(lang);
		localStorage.setItem("locale", lang);
		this.initLang();
		location.reload();
	}
}
